import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 180px;
  margin: 16px;

  .title {
    font-size: 16px;
    margin-bottom: 40px;
  }
  .custom-input{
    position: relative;
    width: 100px;
    left: 0;
    right: 0;
    bottom: 125px;
    margin: auto;
    color: ${(props) => props.theme.colors.text};
    font-size: 35px;
    text-align: center;

    &>.title {
      font-size: 35px;
      font-family: "ManropeBold";
      margin-bottom: 10px;
    }

    &>.subtitle {
      font-size: 11px;
      line-height: 1.3;
      word-break: break-word;
      white-space: pre-line;
    }
  }
`;

export default { Wrapper };
